export default {
  EXTENSION_ID: "apkdlkpcghonmghkbkhhjpaemnmjahgi",
  // BASE_ENDPOINT: "http://localhost:9000",
  BASE_ENDPOINT: "https://api.hexcord.com",
  FIREBASE_KEY: "BPZzbuvJybazQ79sOsXOjCeAt2ZrtohM00SdHFtIO7Q57DmH0bOHf-3HGw4bZgNq6_e32lUGPLRPYWVF8yhdnfQ",
}